var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7786 2.5426C13.4148 2.5426 14.7453 3.87445 14.7454 5.51331C14.7453 6.915 13.777 8.07937 12.4749 8.39319V9.5719H16.5344C16.8547 9.5719 17.1266 9.78171 17.2102 10.0885L20.218 21.191C20.2737 21.4002 20.2252 21.6232 20.093 21.7975C19.9676 21.9647 19.758 22.0699 19.5422 22.0699H4.01489C3.79924 22.0697 3.58933 21.9647 3.46411 21.7975C3.33217 21.6233 3.2836 21.4 3.33911 21.191L6.34692 10.0885C6.43043 9.78185 6.70267 9.57217 7.02271 9.5719H11.0823V8.39319C9.78063 8.07902 8.81277 6.91464 8.81274 5.51331C8.8128 3.87489 10.1428 2.54309 11.7786 2.5426ZM11.7786 3.93713C10.9084 3.93748 10.2043 4.64874 10.2043 5.51331C10.2044 6.13372 10.5673 6.6634 11.0823 6.92151V6.05042C11.0823 5.66009 11.3959 5.35349 11.7786 5.35315C12.1615 5.3532 12.4749 5.65991 12.4749 6.05042V6.92151C12.99 6.66343 13.3518 6.13383 13.3518 5.51331C13.3518 4.64856 12.6489 3.93719 11.7786 3.93713Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeigh);
export default __webpack_public_path__ + "static/media/Weigh.201d261a168f9781b853e8befd2c053b.svg";
export { ForwardRef as ReactComponent };